import { RestaurantCommercialAdmin } from "./RestaurantCommercialAdmin";
import { RestaurantCommercialCustomer } from "./RestaurantCommercialCustomer";
import {
  parseRestaurantCommercialPath,
  restaurantCommercialBusinessName,
  restaurantCommercialStorageSlug,
} from "./restaurant-commercial-routing";

export { RESTAURANT_COMMERCIAL_DEMO_PUBLIC_PATH } from "./restaurant-commercial-routing";

export function RestaurantCommercialDemo({ navigate }: { navigate: (path: string) => void }) {
  const route = parseRestaurantCommercialPath(window.location.pathname);
  const businessSlug = route.businessSlug ?? "casa-nativa";
  const businessName = restaurantCommercialBusinessName(businessSlug);
  const storageSlug = restaurantCommercialStorageSlug(businessSlug);
  const params = new URLSearchParams(window.location.search);

  if (params.get("view") === "admin") {
    return <RestaurantCommercialAdmin
      businessSlug={businessSlug}
      storageSlug={storageSlug}
      businessName={businessName}
      navigate={navigate}
    />;
  }

  return <RestaurantCommercialCustomer
    businessSlug={businessSlug}
    storageSlug={storageSlug}
    businessName={businessName}
    surface={route.surface}
    navigate={navigate}
  />;
}
